<script >
import { ref, computed, watch, inject } from 'vue-demi';
import { Radio, Input, Checkbox, Toast, Loading } from '@futuweb/future-ui';
import { RadioGroup } from '@futuweb/future-ui/es/radio';
import { CheckboxGroup } from '@futuweb/future-ui/es/Checkbox';
import { FORM_TYPE_MAP } from '../assets/enums';
import { fixNum, numToLetter, getLangText } from '../assets/scripts/utils';
import request from '../assets/scripts/request';
const __sfc_main = {};
__sfc_main.props = {
  questions: Array,
  questionStatus: Object,
  userAnswer: Array,
  isPc: Boolean,
  authMode: Number
};
__sfc_main.setup = (__props, __ctx) => {
  const {
    plugins: {
      passport
    }
  } = require('@futuweb/fego-render');
  const commonApiRequest = request.bindCommonApi('question');
  const submitAnswer = async data => {
    return await commonApiRequest.post('submit-answer', data);
  };
  const props = __props;
  const act_sign = inject('act_sign');
  const question_sign = inject('question_sign');
  const lang = inject('lang');
  const $t = inject('$t');
  const emits = __ctx.emit;

  /* == 表单 == */
  // 表单配置
  const formConfig = computed(() => {
    return props.questions.map((q, i) => {
      const {
        type,
        selectType,
        optional,
        option
      } = q;
      let formType = type;
      let placeholder = '';
      // 如果是选择题，需要根据选择类型来确定是单选还是多选
      if (type === 'select') {
        formType = selectType === 'single' ? FORM_TYPE_MAP.RADIO : FORM_TYPE_MAP.CHECKBOX;
      } else {
        placeholder = getLangText(q, 'placeholder', lang);
      }
      const title = getLangText(q, 'title', lang);
      const options = option.map(o => {
        const txt = getLangText(o, 'txt', lang);
        return {
          label: txt,
          value: numToLetter(o.idx)
        };
      });
      return {
        idx: i,
        type: formType,
        title,
        options,
        placeholder,
        optional
      };
    });
  });
  // 是否禁用表单
  const isDisabled = computed(() => {
    const {
      isActive,
      isSubmit
    } = props.questionStatus || {};
    // 已答题 或 未通过筛选 或 未激活
    return isSubmit || !isActive;
  });
  const goLogin = () => {
    if (!window._params.uid && props.authMode) {
      Toast.warning($t('go_login'));
      passport.jumpPassport();
    }
  };

  // 答案处理
  const answer = ref([]);
  const setUserAnswer = val => {
    if (val?.length) {
      answer.value = val.map((item, i) => {
        if (formConfig.value[i].type === FORM_TYPE_MAP.RADIO) {
          return item[0];
        }
        return item;
      });
    }
  };
  watch(() => props.userAnswer, val => {
    val?.length && setUserAnswer(val);
  });

  /* == 提交问卷 == */
  // 校验必填项是否填写
  const isValid = () => {
    for (let i = 0; i < formConfig.value.length; i++) {
      const c = formConfig.value[i];
      if (!c.optional) {
        // 简答题
        if (c.type === FORM_TYPE_MAP.INPUT && !answer.value[c.idx]?.trim()) {
          return false;
        } else if (!answer.value[c.idx]?.length) {
          return false;
        }
      }
    }
    return true;
  };
  // 提交答案
  const submit = async () => {
    goLogin();
    if (isDisabled.value) {
      return;
    }
    if (!window._params.uid && props.authMode) {
      Toast.warning($t('go_login'));
      return passport.jumpPassport();
    }
    if (isValid()) {
      Toast.loading({
        toastClass: 'silky-loading',
        duration: 0
      });
      // 答案格式化
      const finalAnswer = answer.value.map((item, i) => {
        if (formConfig.value[i].type === FORM_TYPE_MAP.RADIO) {
          return [item];
        }
        return item;
      });
      try {
        await submitAnswer({
          act_sign,
          question_sign,
          answer: finalAnswer
        });
        Toast.success($t('submit_succ'));
        emits('refresh');
      } catch (e) {
        Toast.error($t('submit_fail'));
      }
    } else {
      Toast.warning($t('form_required'));
    }
  };
  return {
    FORM_TYPE_MAP,
    fixNum,
    $t,
    formConfig,
    isDisabled,
    goLogin,
    answer,
    submit
  };
};
__sfc_main.components = Object.assign({
  Input,
  RadioGroup,
  Radio,
  CheckboxGroup,
  Checkbox,
  Loading
}, __sfc_main.components);
export default __sfc_main;
</script>
<template>
    <div
        :class="[
            'question-form',
            {
                pc: isPc
            }
        ]"
    >
        <div class="question-item" v-for="config in formConfig" :key="`form_item_${config.idx}`">
            <p class="item-q">
                <span class="item-q-i"> {{ fixNum(config.idx + 1) }}</span>
                <span>
                    <span>{{ config.title }}</span>
                    <template>
                        <span v-if="!config.optional" class="tips warn">*</span>
                        <span v-if="config.type !== FORM_TYPE_MAP.INPUT" class="tips">{{
                            config.type === FORM_TYPE_MAP.RADIO ? $t('single') : $t('multi')
                        }}</span>
                    </template>
                </span>
            </p>
            <div class="item-a">
                <Input
                    v-if="config.type === FORM_TYPE_MAP.INPUT"
                    v-model="answer[config.idx]"
                    type="textarea"
                    :autosize="{ minRows: 2 }"
                    :maxlength="500"
                    shape="card"
                    :placeholder="config.placeholder"
                    :disabled="isDisabled"
                    @change="goLogin"
                />
                <RadioGroup
                    v-else-if="config.type === FORM_TYPE_MAP.RADIO"
                    v-model="answer[config.idx]"
                    direction="vertical"
                    :disabled="isDisabled"
                    @change="goLogin"
                >
                    <Radio
                        v-for="o in config.options"
                        :key="`form_item_options_${config.idx}_${o.value}`"
                        :value="o.value"
                    >
                        {{ o.label }}
                    </Radio>
                </RadioGroup>
                <CheckboxGroup
                    v-else-if="config.type === FORM_TYPE_MAP.CHECKBOX"
                    v-model="answer[config.idx]"
                    direction="vertical"
                    :disabled="isDisabled"
                    @change="goLogin"
                >
                    <Checkbox
                        v-for="o in config.options"
                        :key="`form_item_options_${config.idx}_${o.value}`"
                        :value="o.value"
                    >
                        {{ o.label }}
                    </Checkbox>
                </CheckboxGroup>
            </div>
        </div>
        <div
            :class="[
                'question-submit',
                {
                    disabled: isDisabled
                }
            ]"
        >
            <button v-if="questionStatus" @click="submit">
                {{ $t(questionStatus.isSubmit ? 'submitted' : questionStatus.isActive ? 'submit' : 'expired') }}
            </button>
            <Loading loading-class="silky-loading" v-else></Loading>
        </div>
    </div>
</template>
<style lang="less">
@keyframes van-rotate {
    from {
        transform: rotate(0deg);
    }

    to {
        transform: rotate(360deg);
    }
}
.silky-loading .ui-indicator-flower {
    animation: van-rotate 0.8s linear infinite;
}
</style>
<style lang="less" scoped>
@import './index.less';
.question-form {
    margin-top: 0.1rem;

    .question-item {
        padding: var(--question-item-padding);
    }
    .item-q {
        color: #121212;
        font-size: var(--question-q-font-size);
        line-height: var(--question-q-line-height);
        display: flex;
        .item-q-i {
            margin-right: 0.2rem;
        }
        .tips {
            color: #959595;
            font-size: var(---question-q-tips-font-size);
            letter-spacing: -0.01rem;
        }
        .warn {
            color: #f13e3a;
        }
    }
    .item-a {
        margin-top: var(--question-a-margin-top);
        padding: var(--question-a-padding);
    }

    .question-submit {
        margin-top: 0.3rem;
        text-align: center;
        font-weight: 600;
        > button {
            width: 4rem;
            font-size: var(--question-submit-font-size);
            height: var(--question-submit-height);
            border-radius: var(--question-submit-raduis);
            background-color: #262626;
            color: #ffffff;
            border: none;
        }
        &.disabled {
            > button {
                background-color: #e2e2e2;
            }
        }
    }
}
</style>
